export { LandingMobileApp } from './lib/landing-mobile-app'

export { getStaticProps } from './lib/get-static-props'
